<template>
    <div :id="'radio--' + component_id">
        <div v-if="options_loaded && passed_filter && panel_required">
            <div class="radiooption stylesoption" v-if="!loading">
                <span>Split Spindle:</span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandleSplitSpindle from "../DesignerQuestionHardwareHandleSplitSpindle.vue";
    import SynsealRadioQuestion from "../mixin/synseal/RadioQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandleSplitSpindle,
            SynsealRadioQuestion
        ],
    }
</script>
